module.exports = __webpack_public_path__ + "static/media/v2.4a1d644.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work5/v2.mp4
// module id = MU5j
// module chunks = 0